import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guarantor-maintenance',
  templateUrl: './guarantor-maintenance.component.html',
})
export class GuarantorMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
